<!-- @veltra/icons generated sha256:43729bdad5993cfc gen:8 source:src/svg/normal/page-first.svg -->
<script setup lang="ts">
defineOptions({ name: 'PageFirst' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m11.942 3.996-.01-.01a.63.63 0 0 0-.905.013L7.38 7.648a.497.497 0 0 0 0 .704l3.648 3.65a.634.634 0 0 0 .905.012l.01-.01a.65.65 0 0 0 .006-.92L8.865 8l3.083-3.083a.65.65 0 0 0-.006-.92m-7.146.66v6.685c0 .36.295.658.654.658h.015c.36 0 .63-.299.63-.658V4.658A.66.66 0 0 0 5.442 4a.66.66 0 0 0-.645.658"
    />
  </svg>
</template>
